import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import SwitchToggle from 'components/Basic/SwitchToggle/SwitchToggle';
import { toggleFacetLabels } from 'store/slices/RoofEditSlice';
import useQueriesRunningInBackGround from 'hooks/useQueriesRunningInBackGround';
import { FacetLabelToggle } from './style';
import { PanelElement } from 'components/DisplayEnergy/style';

export default function ShowFacetLabelsToggle() {
	const dispatch = useDispatch();
	const { showFacetLabels } = useSelector(
		(state: RootState) => state.roofEditData.data
	);
	const hideSatelliteOverlay = useSelector((state: RootState) => state.toolNewPostions.data.hideSatelliteOverlay);
	const queriesRunningInBackGround = useQueriesRunningInBackGround();

	return (
		<PanelElement style={{ zIndex: 0 }}>
			<FacetLabelToggle className="switchButton showfacet-toggle">
				<span>Show facet labels</span>
				<SwitchToggle
					checked={showFacetLabels}
					onChange={() =>
						dispatch(toggleFacetLabels({ val: !showFacetLabels }))
					}
					disabled={queriesRunningInBackGround || hideSatelliteOverlay}
				/>
			</FacetLabelToggle>
		</PanelElement>
	);
}
